import { BackupOutlined } from "@material-ui/icons";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";
import {
  AttachmentFilesCard,
  FormLabel,
  PrimaryButton,
  SecondaryButton,
} from "components";
import { useCallback, useMemo, useState } from "react";
import { useDropzone } from "react-dropzone";
import { globalStyles } from "styles";
import { formatFileSize, stringTruncate } from "utils";

const ModalUploadPayment = ({ open, onClose, loadingButton, onSubmit }) => {
  const classes = globalStyles();
  const [documentFiles, setDocumentFiles] = useState([]);

  const onDrop = useCallback(acceptedFiles => {
    setDocumentFiles(prev => [...prev, ...acceptedFiles]);
  }, []);
  const handleRemoveFile = idx => {
    setDocumentFiles(prevFiles => prevFiles.filter((_, i) => i !== idx));
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: true,
  });
  const dropzoneStyle = useMemo(() => {
    return isDragActive ? classes?.dragActive : "";
  }, [isDragActive, classes.activeStyle]);

  const handleSubmit = () => {
    onSubmit(documentFiles);
  };

  return (
    <Dialog
      open={open}
      onClose={!loadingButton && onClose}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>Upload Payment Proof</DialogTitle>
      <DialogContent dividers>
        <div
          {...getRootProps({
            className: `${classes.dragFilesContainer} ${dropzoneStyle}`,
          })}
        >
          <input {...getInputProps()} />
          <Box color="grey">
            <BackupOutlined className={classes?.uploadIcon} />
          </Box>
          <Typography>
            {isDragActive
              ? "Drop the files here..."
              : "Drag files or click to upload"}
          </Typography>
        </div>
        <Box mt="16px">
          <FormLabel label="Document Attached" />
          {documentFiles.length > 0 && (
            <Box maxHeight={300} overflow="auto">
              <Grid container direction="column" rowSpacing={1} mt={1}>
                {documentFiles?.map(({ file_path, name, size }, index) => (
                  <Grid item key={index}>
                    <AttachmentFilesCard
                      fileName={stringTruncate(name, 50)}
                      fileSize={formatFileSize(size)}
                      handleRemove={() => handleRemoveFile(index)}
                      filePath={file_path}
                      tooltipRemove="Remove File"
                    />
                  </Grid>
                ))}
              </Grid>
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <SecondaryButton
          label="Cancel"
          onClick={onClose}
          disabled={loadingButton}
        />
        <PrimaryButton
          label={loadingButton ? "Uploading" : "Upload"}
          disabled={loadingButton}
          loading={loadingButton}
          onClick={handleSubmit}
        />
      </DialogActions>
    </Dialog>
  );
};

export default ModalUploadPayment;
